
import { Component, Prop, Vue } from "nuxt-property-decorator";
import FaqAnswerText from "./FaqAnswerText.vue";
import DeliveryOptionsText from "~/components/molecules/display/DeliveryOptionsText.vue";
import RouterLink from "~/components/atoms/text/RouterLink.vue";

@Component({
  components: {
    FaqAnswerText,
    DeliveryOptionsText,
    RouterLink,
  },
})
export default class FaqAnswer extends Vue {
  @Prop() item: any;
  @Prop() index: number;
}
